import { INSTRUCTION_TYPE } from "@/types/instruction";

export const getTypeLabel = (type: INSTRUCTION_TYPE, mode: string) => {
  if (type === INSTRUCTION_TYPE.POLICY)
    return mode === "create" ? "방침 등록" : mode === "edit" ? "방침 수정" : "방침 상세";
  return mode === "create" ? "지시사항 등록" : mode === "edit" ? "지시사항 수정" : "지시사항 상세";
};
